import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'services/localization';
import useShopFormat from 'hooks/useShopFormat';
import { timeslotToString } from 'common/modules/delivery/utils';
import { DeliveryTimeSlot } from 'common/types';
import { useSelector } from 'react-redux';

import * as ShopSelectors from 'selectors/ShopSelectors';

export interface Props {
	type: 'delivery' | 'pickup' | 'self-return';
	timeslot?: DeliveryTimeSlot | null;
	dateString?: string;
}
const DeliveryHeader = (props: Props) => {
	const { type, timeslot, dateString } = props;
	const { t } = useTranslation();
	const { shopDateFormat } = useShopFormat();
	const shopTimezone = useSelector(ShopSelectors.getShopTimeZone);

	const heading = (() => {
		switch (type) {
			case 'delivery':
				return t('delivery.delivery', 'Delivery');
			case 'pickup':
				return t('delivery.pickup', 'Pickup');
			case 'self-return':
				return t('delivery.selfReturn', 'Self-return');
		}
	})();

	return (
		<Stack direction="column">
			<Typography variant="body1" fontSize="1.8rem" fontWeight={500}>
				{heading}
			</Typography>
			<Typography variant="body1" color="secondary" fontSize="1.4rem">
				{!!timeslot
					? timeslotToString({
							timeslot: timeslot,
							shopDateFormat,
							timezone: shopTimezone,
					  })
					: dateString}
			</Typography>
		</Stack>
	);
};

export default DeliveryHeader;
